export type MatchRouteState = {
  prefilledClubId: number | null;
  shouldOpenCreate: boolean;
};

export function readMatchRouteState(hash: string): MatchRouteState {
  const rawHash = String(hash || "");
  const [, queryPart = ""] = rawHash.split("?");
  const query = new URLSearchParams(queryPart);
  const clubId = Number(query.get("club") || query.get("clubId") || "");
  const createRaw = String(query.get("create") || "").trim().toLowerCase();

  return {
    prefilledClubId: Number.isFinite(clubId) && clubId > 0 ? clubId : null,
    shouldOpenCreate:
      createRaw === "1" ||
      createRaw === "true" ||
      createRaw === "sim" ||
      createRaw === "yes",
  };
}
